import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { InputNumber as AntInputNumber } from 'antd';

class InputNumber extends Component {
  componentDidMount() {
    const inputMode = this.props.inputMode || 'numeric';
    ReactDOM.findDOMNode(this)
      .getElementsByTagName('input')[0]
      .setAttribute('inputmode', inputMode);
  }

  render() {
    return React.createElement(AntInputNumber, {
      ...this.props,
      pattern: '[0-9.]*'
    });
  }
}

export default InputNumber;
